<ng-container *ngIf="showPlayer">
  <div class="fixed-bottom-player">
    <div class="float-right">
      <nav class="navbar-expand navbar-dark bg-player p-2"
           style="border-top-left-radius: 10px;"
           *ngIf="flagBanner == true">
        <div class="collapse navbar-collapse show" id="navbarCollapse">
          <img class="albumart-player animated fadeIn player-banner" 
               src="{{ urlImage }}{{ imgBannerAlbumart }}" 
               *ngIf="imgBannerAlbumart != null">
        </div>
      </nav>
  
      <!-- style="border-top-left-radius: 10px;" -->
      <nav class="navbar-expand navbar-dark bg-player nav-player rounded-1 pt-2 px-2 pb-1">
        <div class="collapse navbar-collapse show" id="navbarCollapse">
          <ul class="navbar-nav mr-auto nav-player-ul">
            <li class="nav-item active mt-2 btnPlay">
                <span class="nav-link pt-20">
                  <i *ngIf="playFlag" class="fa fa-pause cursor-pointer fa-2x animated rubberBand delay-1s" (click)="toggleAudio()"></i>
                  <i *ngIf="!playFlag" class="fa fa-play cursor-pointer fa-2x animated rubberBand delay-1s" (click)="toggleAudio()"></i>
                </span>
            </li>
            <li class="nav-item pl-3 text-center infoSong cursor-pointer" (click)="toggleAudio()">
              <span class="nav-link label-player">
                {{ auxArtista || 'Artista desconocido' }}
                <br>
                {{ auxSong || 'Sin frecuencia' }}
              </span>
            </li>
            <ng-container *ngIf="replyAlbumart != null else showImgGrupoAs;">
              <li class="nav-item pl-3 playerAlbumart cursor-pointer" (click)="toggleAudio()">
                <img class="albumart-player rounded-1 animated bounceIn delay-3s" src="{{ replyAlbumart['albumart'] }}" alt="albumart" width="60">
              </li>
            </ng-container>
            <ng-template #showImgGrupoAs>
              <li class="nav-item pl-3 playerAlbumart cursor-pointer" (click)="toggleAudio()">
                <img class="albumart-player rounded-1 animated bounceIn delay-3s" src="{{ imageStation }}" alt="albumart">
              </li>
            </ng-template>
          </ul>
        </div>
      </nav>
    </div>
  </div>  
</ng-container>
